import { ILogger } from "flow/interfaces/ILogger";

export default class PrefixedLogger implements ILogger {
    constructor(protected readonly prefix: string) {}

    debug(...params: any[]) {
        if (console && console.debug) {
            console.debug(this.prefix, ...params);
        }
    }

    log(...params: any[]) {
        if (console && console.log) {
            console.log(this.prefix, ...params);
        }
    }

    info(...params: any[]) {
        if (console && console.info) {
            console.info(this.prefix, ...params);
        }
    }

    warn(...params: any[]) {
        if (console && console.warn) {
            console.warn(this.prefix, ...params);
        }
    }

    error(...params: any[]) {
        if (console && console.error) {
            console.error(this.prefix, ...params);
        }
    }
}
